export const ru = {
    'cant-read-unexpected-data': 'Неправильная структура данных',
    'required-not-empty-field':
        'Обязательное поле, ожидаем не пустое значение. Колонка: {columns}, адрес ячейки: {address}',
    'unknown-error-text': 'Произошла непредвиденная ошибка. Повторите попытку позже',
    'wrong-value-format': 'Неправильное значение поля'
};
